import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import {
    HydrateFilterDataFilterInput,
    ClientUserFilterDataFilterInput,
    CoreUserFilterDataFilterInput,
    PlanFilterDataFilterInput,
    TaskCategoryFilterDataFilterInput,
    TeamFilterDataFilterInput,
    WorkspaceFilterDataFilterInput,
    StaticDataFilterInput,
} from './inputs';
import {
    HydratedFilterResource,
    ClientUserResource,
    CoreUserResource,
    PlanResource,
    TaskCategoryResource,
    TeamResource,
    WorkspaceResource,
    StaticFilterDataResource,
} from './resources';

export default class Filter {
    private basePath = '/api/filter';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Fetch static data for filter
    getStaticData = async (filter?: StaticDataFilterInput): Promise<StaticFilterDataResource> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/static-data?${query}`);

        return data;
    };

    // Hydrate filter data
    hydrateData = async (filter?: HydrateFilterDataFilterInput): Promise<HydratedFilterResource> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/hydrate?${query}`);

        return data;
    };

    // Get client user data
    getClientUserData = async (
        filter: ClientUserFilterDataFilterInput
    ): Promise<CollectionResource<ClientUserResource, {}>> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/data/client-user?${query}`);

        return data;
    };

    // Get core user data
    getCoreUserData = async (
        filter: CoreUserFilterDataFilterInput
    ): Promise<CollectionResource<CoreUserResource, {}>> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/data/core-user?${query}`);

        return data;
    };

    // Get plan data
    getPlanData = async (filter?: PlanFilterDataFilterInput): Promise<CollectionResource<PlanResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/data/plan?${query}`);

        return data;
    };

    // Get task category data
    getTaskCategoryData = async (
        filter?: TaskCategoryFilterDataFilterInput
    ): Promise<CollectionResource<TaskCategoryResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/data/task-category?${query}`);

        return data;
    };

    // Get team data
    getTeamData = async (filter?: TeamFilterDataFilterInput): Promise<CollectionResource<TeamResource, {}>> => {
        const query = qs.stringify({ ...(filter || {}) });

        const { data } = await this.http.get(`${this.basePath}/data/team?${query}`);

        return data;
    };

    // Get workspace data
    getWorkspaceData = async (
        filter: WorkspaceFilterDataFilterInput
    ): Promise<CollectionResource<WorkspaceResource, {}>> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/data/workspace?${query}`);

        return data;
    };
}
